import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import Avatar from "../../common/Avatar";
import Button from "../../ui/Button";
import DropdownMenu from "../../ui/DropdownMenu";
import ListItem from "../../ui/ListItem";
import MenuItem from "../../ui/MenuItem";
import SearchInput from "../../ui/SearchInput";
import { MapAndroidMsgToLotMessage } from "../tdlib/tdlib";
import { NativeRestApi } from "../websocket/nativeRestApi";
import MessageItem from "./ui/MessageItem";

type OwnProps = {
    threadId: number,
    onBackToConversation?: () => void;
    conversation: any;
    onTransMessagesFromSelectedToParse: (messages: any[]) => void;
}

const PhoneMessages: FC<OwnProps> = ({
    threadId,
    onBackToConversation,
    conversation,
    onTransMessagesFromSelectedToParse,
}) => {
    const [state, setState] = useState({
        messages: [] as any,
        selectedMessageIds: [] as any[],
        chat: { title: "" },
        sourToGet: "messages" as "deletedMessages" | "editedMessages" | "messages",
        inSelectMessageMode: false,
    })
    useEffect(() => {
        NativeRestApi.getAllMessagesByConv(threadId).then(res => {
            if (res && res.message) {
                const data = JSON.parse(res.message)
                setState(prev => ({ ...prev, messages: data }))
            }
        })
    }, [])
    async function handleTransMessagesFromSelectedToParse() {
        const filtered = state.messages.filter((msg: any) => state.selectedMessageIds.includes(msg.id))
        const lotMessages: any[] = []
        for (let msg of filtered) {
            const lotMsg = await MapAndroidMsgToLotMessage(msg)
            if (lotMsg != null)
                lotMessages.push(lotMsg)
        }
        onTransMessagesFromSelectedToParse(lotMessages)
    }
    function handleMessageOnClick(dataItem: any) {
        let tmp = state.selectedMessageIds
        if (state.inSelectMessageMode) {
            if (state.selectedMessageIds.includes(dataItem.id)) {
                tmp = state.selectedMessageIds.filter(id => id != dataItem.id)
            } else {
                tmp.push(dataItem.id)
            }
        }
        setState(prev => ({ ...prev, selectedMessageIds: tmp }))
    }
    return (
        <div>
            <div className="toolbar">


                <div className=" common-container-row" >
                    <div className="common-container-row left-panel">
                        <Button
                            round
                            size="smaller"
                            color="translucent"
                            onClick={() => {
                                if (onBackToConversation)
                                    onBackToConversation()
                            }}
                        >
                            <i className="icon icon-arrow-left" />
                        </Button>
                        <Avatar size="small" text={state.chat.title} />
                        <div>{state.chat.title
                            + (state.selectedMessageIds.length > 0
                                ? ` (đã chọn ${state.selectedMessageIds.length}/${state.messages.length})`
                                : "")}</div>
                    </div>
                    <div className="common-container-row right-panel">
                        <DropdownMenu positionX="right">
                            {
                                state.selectedMessageIds.length > 0 &&
                                <>
                                    <MenuItem
                                        onClick={() => handleTransMessagesFromSelectedToParse()}
                                    >
                                        Phân tích tin đã chọn
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => setState(prev => ({ ...prev, danhDauBoDialogOpen: true }))}
                                    >
                                        Đánh dấu bỏ các tin đã chọn
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => setState(prev => ({ ...prev, xoaTinDialogOpen: true }))}
                                    >
                                        Xoá các tin đã chọn
                                    </MenuItem>
                                </>
                            }
                            {/*  <MenuItem onClick={() => {
                                setState(prev => ({ ...prev, sourToGet: "messages" }))
                            }}
                                icon={state.sourToGet == "messages" ? "icon icon-check" : ""}
                            >Tin nhắn thông thường</MenuItem>
                            <MenuItem onClick={() => {
                                setState(prev => ({ ...prev, sourToGet: "editedMessages" }))
                            }}
                                icon={state.sourToGet == "editedMessages" ? "icon icon-check" : ""}
                            >Tin bị sửa</MenuItem>
                            <MenuItem
                                onClick={() => {
                                    setState(prev => ({ ...prev, sourToGet: "deletedMessages" }))
                                }}
                                icon={state.sourToGet == "deletedMessages" ? "icon icon-check" : ""}
                            >Tin bị xoá</MenuItem> */}
                            <MenuItem
                                onClick={() => {
                                    const newSelectMode = !state.inSelectMessageMode
                                    setState(prev => ({ ...prev, inSelectMessageMode: newSelectMode }))
                                    if (!newSelectMode) {
                                        setState(prev => ({ ...prev, selectedMessageIds: [] }))
                                    }
                                }}

                            >Chọn tin nhắn</MenuItem>
                        </DropdownMenu>
                    </div>
                </div>
            </div>
            {/* <div className="header" >
                <Button round size="smaller"
                    onClick={() => {
                        if (onBackToConversation) {
                            onBackToConversation()
                        }
                    }}
                ><i className=" icon icon-arrow-left"></i></Button>
                <div className="search">
                    <SearchInput onChange={(e) => {
                        
                    }} />
                </div>
            </div> */}
            {
                state.messages.map((it: any, index: number) => {
                    return <div key={`msg${index}`}>

                        <MessageItem dataItem={it}
                            inSelectMode={state.inSelectMessageMode}
                            selected={state.selectedMessageIds.includes(it.id)}
                            onClick={handleMessageOnClick}
                        ></MessageItem>

                    </div>
                })
            }
        </div>
    )
}
export default memo(PhoneMessages)